import { lazyNamedWithRetry } from '@/lib/lazyWithRetry';

const lazyNamed = lazyNamedWithRetry;

export const ShopPage = lazyNamed(() => import('@/pages/ShopPage'), 'ShopPage');
export const VendorsPage = lazyNamed(() => import('@/pages/VendorsPage'), 'VendorsPage');
export const BusinessProfilePage = lazyNamed(
  () => import('@/pages/BusinessProfilePage'),
  'BusinessProfilePage',
);
export const ProductDetailPage = lazyNamed(
  () => import('@/pages/ProductDetailPage'),
  'ProductDetailPage',
);
export const StorePage = lazyNamed(() => import('@/pages/StorePage'), 'StorePage');
export const CartPage = lazyNamed(() => import('@/pages/CartPage'), 'CartPage');
export const CheckoutPage = lazyNamed(() => import('@/pages/CheckoutPage'), 'CheckoutPage');
export const FindProPage = lazyNamed(() => import('@/pages/FindProPage'), 'FindProPage');
export const ProDetailPage = lazyNamed(() => import('@/pages/ProDetailPage'), 'ProDetailPage');
export const ClassifiedsPage = lazyNamed(
  () => import('@/pages/ClassifiedsPage'),
  'ClassifiedsPage',
);
export const ClassifiedDetailPage = lazyNamed(
  () => import('@/pages/ClassifiedDetailPage'),
  'ClassifiedDetailPage',
);
export const ClassifiedPostPage = lazyNamed(
  () => import('@/pages/ClassifiedPostPage'),
  'ClassifiedPostPage',
);
export const PropertyPage = lazyNamed(() => import('@/pages/PropertyPage'), 'PropertyPage');
export const PropertyDetailPage = lazyNamed(
  () => import('@/pages/PropertyDetailPage'),
  'PropertyDetailPage',
);
export const SearchPage = lazyNamed(() => import('@/pages/SearchPage'), 'SearchPage');
export const MessagesPage = lazyNamed(() => import('@/pages/MessagesPage'), 'MessagesPage');
export const OrdersPage = lazyNamed(() => import('@/pages/OrdersPage'), 'OrdersPage');
export const OrderDetailPage = lazyNamed(
  () => import('@/pages/OrderDetailPage'),
  'OrderDetailPage',
);
export const ServiceRequestsPage = lazyNamed(
  () => import('@/pages/ServiceRequestsPage'),
  'ServiceRequestsPage',
);
export const BoostAdsPage = lazyNamed(() => import('@/pages/BoostAdsPage'), 'BoostAdsPage');
export const LoginPage = lazyNamed(() => import('@/pages/LoginPage'), 'LoginPage');
export const RegisterPage = lazyNamed(() => import('@/pages/RegisterPage'), 'RegisterPage');
export const ConfirmEmailPage = lazyNamed(
  () => import('@/pages/ConfirmEmailPage'),
  'ConfirmEmailPage',
);
export const ForgotPasswordPage = lazyNamed(
  () => import('@/pages/ForgotPasswordPage'),
  'ForgotPasswordPage',
);
export const ResetPasswordPage = lazyNamed(
  () => import('@/pages/ResetPasswordPage'),
  'ResetPasswordPage',
);
export const AccountSetupPage = lazyNamed(
  () => import('@/pages/AccountSetupPage'),
  'AccountSetupPage',
);
export const ShopAssistantPage = lazyNamed(
  () => import('@/pages/ShopAssistantPage'),
  'ShopAssistantPage',
);
export const WishlistPage = lazyNamed(() => import('@/pages/WishlistPage'), 'WishlistPage');
export const ReturnsPage = lazyNamed(() => import('@/pages/ReturnsPage'), 'ReturnsPage');
export const VendorPricingPage = lazyNamed(
  () => import('@/pages/VendorPricingPage'),
  'VendorPricingPage',
);
export const VendorOnboardingPage = lazyNamed(
  () => import('@/pages/VendorOnboardingPage'),
  'VendorOnboardingPage',
);
export const JoinOnboardingPage = lazyNamed(
  () => import('@/pages/JoinOnboardingPage'),
  'JoinOnboardingPage',
);
export const AcceptInvitePage = lazyNamed(
  () => import('@/pages/AcceptInvitePage'),
  'AcceptInvitePage',
);
export const BecomeAProPage = lazyNamed(() => import('@/pages/BecomeAProPage'), 'BecomeAProPage');
export const ProOnboardingPage = lazyNamed(
  () => import('@/pages/ProOnboardingPage'),
  'ProOnboardingPage',
);
export const AdvertisePage = lazyNamed(() => import('@/pages/AdvertisePage'), 'AdvertisePage');
export const AboutPage = lazyNamed(() => import('@/pages/AboutPage'), 'AboutPage');
export const NotificationPrefsPage = lazyNamed(
  () => import('@/pages/NotificationPrefsPage'),
  'NotificationPrefsPage',
);
export const TermsPage = lazyNamed(() => import('@/pages/TermsPage'), 'TermsPage');
export const PrivacyPage = lazyNamed(() => import('@/pages/PrivacyPage'), 'PrivacyPage');
export const NotFoundPage = lazyNamed(() => import('@/pages/NotFoundPage'), 'NotFoundPage');
export const SavedCardsPage = lazyNamed(() => import('@/pages/SavedCardsPage'), 'SavedCardsPage');
export const OrderTrackingPage = lazyNamed(
  () => import('@/pages/OrderTrackingPage'),
  'OrderTrackingPage',
);
export const DealsPage = lazyNamed(() => import('@/pages/DealsPage'), 'DealsPage');
export const LoyaltyPage = lazyNamed(() => import('@/pages/LoyaltyPage'), 'LoyaltyPage');
export const ReferralPage = lazyNamed(() => import('@/pages/ReferralPage'), 'ReferralPage');
export const GiftCardsPage = lazyNamed(() => import('@/pages/GiftCardsPage'), 'GiftCardsPage');
export const ConnectOnboardPage = lazyNamed(
  () => import('@/pages/connect/ConnectOnboardPage'),
  'ConnectOnboardPage',
);
export const ConnectProductsPage = lazyNamed(
  () => import('@/pages/connect/ConnectProductsPage'),
  'ConnectProductsPage',
);
export const ConnectStorePage = lazyNamed(
  () => import('@/pages/connect/ConnectStorePage'),
  'ConnectStorePage',
);
export const ConnectSuccessPage = lazyNamed(
  () => import('@/pages/connect/ConnectSuccessPage'),
  'ConnectSuccessPage',
);
export const AccountSettingsPage = lazyNamed(
  () => import('@/pages/AccountSettingsPage'),
  'AccountSettingsPage',
);
export const GrenadaHubPage = lazyNamed(
  () => import('@/pages/grenada/GrenadaHubPage'),
  'GrenadaHubPage',
);
export const GrenadaCategoryPage = lazyNamed(
  () => import('@/pages/grenada/GrenadaCategoryPage'),
  'GrenadaCategoryPage',
);
export const ParishCategoryPage = lazyNamed(
  () => import('@/pages/grenada/ParishCategoryPage'),
  'ParishCategoryPage',
);
export const MadeInGrenadaPage = lazyNamed(
  () => import('@/pages/grenada/MadeInGrenadaPage'),
  'MadeInGrenadaPage',
);
export const FindAProGrenadaPage = lazyNamed(
  () => import('@/pages/grenada/FindAProGrenadaPage'),
  'FindAProGrenadaPage',
);
export const SolarHubPage = lazyNamed(
  () => import('@/pages/grenada/solar/SolarHubPage'),
  'SolarHubPage',
);
export const SolarInstallersPage = lazyNamed(
  () => import('@/pages/grenada/solar/SolarInstallersPage'),
  'SolarInstallersPage',
);
export const SolarCompanyPage = lazyNamed(
  () => import('@/pages/grenada/solar/SolarCompanyPage'),
  'SolarCompanyPage',
);
export const SolarParishPage = lazyNamed(
  () => import('@/pages/grenada/solar/SolarParishPage'),
  'SolarParishPage',
);
export const SolarProductsPage = lazyNamed(
  () => import('@/pages/grenada/solar/SolarProductsPage'),
  'SolarProductsPage',
);
